export default {
  submit: "提交",
  search: "搜尋",
  reset: "重置",
  select: "選擇",
  create: "建立",
  update: "更新",
  edit: "編輯",
  delete: "刪除",
  add: "新增",
  remove: "移除",
  cancel: "取消",
  save: "儲存",
  saved: "已儲存",
  loading: "載入中...",
  error: "錯誤",
  success: "成功",
  warning: "警告",
  info: "資訊",
  date: "日期",
  time: "時間",
  today: "今天",
  yesterday: "昨天",
  tomorrow: "明天",
  lastDays: "最近 {days} 天",
  upgrade: "升級",
  import: "匯入",
  export: "匯出",
  ok: "確定",
  close: "關閉",
  clear: "清除",
  retry: "重試",
  upload: "上傳",
  row: "第 {row} 行",
  items: "項目",
  yes: "是",
  no: "否",
  utc: "UTC",
  london: "倫敦",
  paris: "巴黎",
  berlin: "柏林",
  shanghai: "上海",
  new_york: "紐約",
  los_angeles: "洛杉磯",
  privacy_policy: "查看隱私政策",
  email_placeholder: "請輸入您的電子郵箱地址",
  empty_chart_action: "立即計算",
  preview: "預覽",
  sign_out: "登出",
  invoice: "發票",
  credit_notes: "貸項憑證",
  filter: "篩選",
  trendChart: {
    export_image: "匯出圖片",
    this_month: "本月",
    last_month: "上個月",
    month_before_last: "上上個月",
    this_week: "本週",
    last_2_weeks: "最近 2 週",
    last_4_weeks: "最近 4 週",
    today: "今天",
    yesterday: "昨天",
    day_before_yesterday: "前天",
    month: "月",
    week: "週",
    day: "日",
    export_failed: "圖表匯出失敗",
    export_retry: "圖表匯出失敗，請重試",
  },
  view_all_news: "查看所有新聞",
  confirm: "確認",
  rangeSearch: "範圍搜尋",
  leg: {
    origin: "起點",
    destination: "目的地",
    transportMode: "運輸方式",
    distance: "距離 (km)",
    weight: "重量 (t)",
    cnCode: "商品編碼",
    transportEmission: "運輸排放 (kg CO2e)",
    productionEmission: "生產排放 (kg CO2e)",
    totalEmission: "總排放 (kg CO2e)",
  },
  previewReports: {
    pdfPreview: "PDF 預覽",
    excelPreview: "Excel 預覽",
    payPerUse: "已超過限制，是否按使用付費？",
    payPerUseDownload: "按使用付費下載",
    download: "下載",
    refresh: "重新整理",
    darkModeWarning: "深色模式僅用於預覽使用者介面，不會影響匯出的檔案。匯出的檔案保持白色背景樣式",
    upgradeToUnlockExcel: "升級到專業版以解鎖 Excel 預覽",
    unlockFeatures: "解鎖 Excel 匯出、自訂商標、多語言和其他進階功能，提升報告專業性！",
    upgradeNow: "立即升級",
    previewFailed: "預覽失敗",
    excelPreviewRequiresPro: "Excel 預覽需要專業版訂閱！",
    limitReached: "已達到每日或每月限制",
    saved: "儲存成功，您可以在報告列表中查看",
  },
  select_status: "選擇狀態",
  select_plan_type: "選擇方案類型",
  refund: "退款",
  view: "查看",
  start_date: "開始日期",
  end_date: "結束日期",
  view_details: "查看詳情",
  back_to_login: "返回登入",
  view_count_description: "瀏覽次數代表透過分享訪問此報告的總次數。取消分享不會重置此計數器。",
  notify: {
    auto_renew: "自動續訂",
    auto_renew_desc: "啟用以在帳單週期結束時自動續訂您的訂閱。",
  },
  ticketTypes: {
    technical: "技術問題",
    billing: "帳單問題",
    compliance: "合規諮詢",
    feedback: "意見和建議",
    other: "其他",
  },
  loading_verification: "正在載入驗證...",
  billing: {
    current_plan: "目前方案",
    upgrade: "查看升級",
    manage: "查看帳單",
    plan_type: "方案類型",
    next_billing: "下次帳單日期",
    expiry_date: "到期日期",
    expired: "已過期",
    permanent: "永久",
  },
  faq: {
    search_placeholder: "搜尋常見問題...",
    no_results_title: "未找到結果",
    no_results_subtitle: "嘗試調整搜尋詞語或瀏覽左側分類。",
    search_cleared_message: "已清除搜尋以顯示完整內容",
    still_have_questions: {
      before_email: "還有疑問嗎？請聯絡我們 ",
      after_email: " — 我們的團隊將在 24 小時內回覆。",
    },
  },
};
